import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import Button from '../ui/Button';

const { FiClock, FiAward, FiUser } = FiIcons;

const CATEGORIES = ['All', 'Safety', 'Domestic Worker', 'Foreign Worker', 'Corporate'];

const PROGRAMS = [
  { title: 'Construction Safety Orientation', cat: 'Safety', duration: '2 Days', cert: 'MOM Accredited', audience: 'Construction Workers', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379358/1_w652kx.png' },
  { title: 'Settling-In Programme (SIP)', cat: 'Domestic Worker', duration: '1 Day', cert: 'MOM Mandatory', audience: 'First-time FDWs', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379407/2_bzxcey.png' },
  { title: 'Workplace Hazard Awareness', cat: 'Safety', duration: 'Half Day', cert: 'Certificate of Attendance', audience: 'All Employees', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379754/11_id4xmo.png' },
  { title: 'Site Induction for Foreign Workers', cat: 'Foreign Worker', duration: '1 Day', cert: 'Site Specific', audience: 'New Foreign Workers', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379474/5_vynu2x.png' },
  { title: 'Emergency Response Training', cat: 'Corporate', duration: '2 Days', cert: 'SCDF Recognized', audience: 'Corporate ERT Members', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379628/8_nqiwb2.png' },
  { title: 'Employer Compliance Workshop', cat: 'Corporate', duration: 'Half Day', cert: 'Consultancy Cert', audience: 'HR & Employers', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379524/6_og7pcd.png' },
];

const Programs = () => {
  const [activeFilter, setActiveFilter] = useState('All');

  const filteredPrograms = PROGRAMS.filter(p => activeFilter === 'All' || p.cat === activeFilter);

  return (
    <section id="programs" className="py-24 bg-alpha-grayLight relative">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <h2 className="text-alpha-green font-semibold tracking-wider uppercase mb-2 text-sm">Training Catalogue</h2>
            <h3 className="text-3xl md:text-4xl font-bold text-alpha-navy">Explore Our Programs</h3>
          </div>
          
          {/* Filters */}
          <div className="flex flex-wrap gap-2">
            {CATEGORIES.map(cat => (
              <button
                key={cat}
                onClick={() => setActiveFilter(cat)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  activeFilter === cat 
                    ? 'bg-alpha-navy text-white shadow-md' 
                    : 'bg-white text-alpha-grayDark hover:bg-gray-100 border border-gray-200'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Program Grid */}
        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <AnimatePresence>
            {filteredPrograms.map((program) => (
              <motion.div
                key={program.title}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.3 }}
                className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow border border-gray-100 flex flex-col"
              >
                <div className="h-48 overflow-hidden relative">
                  <img src={program.img} alt={program.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-alpha-navy">
                    {program.cat}
                  </div>
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <h4 className="text-xl font-bold text-alpha-navy mb-4 line-clamp-2">{program.title}</h4>
                  
                  <div className="space-y-2 mb-6 flex-grow text-sm text-alpha-grayDark">
                    <div className="flex items-center gap-2">
                      <SafeIcon icon={FiClock} className="text-alpha-green" />
                      <span>{program.duration}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <SafeIcon icon={FiAward} className="text-alpha-green" />
                      <span>{program.cert}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <SafeIcon icon={FiUser} className="text-alpha-green" />
                      <span>{program.audience}</span>
                    </div>
                  </div>
                  
                  <Button variant="outline" className="w-full py-2 text-sm">
                    View Details
                  </Button>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};

export default Programs;